<template>
  <div class="pa-16">
    <v-select
      class="mt-5"
      label="Ryhmittele (rivit)"
      :items="possibleGroupBys"
      item-text="text"
      item-value="value"
      hide-details
      clearable
      return-object
    ></v-select>
    <ChooseGroupBy
      class="mt-10"
      v-if="settings.pivot"
      label="Kolumnit"
      v-model="settings.groupBy"
    />
    <v-select
      class="mt-5"
      label="Aggregointi"
      chips
      multiple
      :items="possibleAggregations"
      item-text="text"
      item-value="value"
      hide-details
      clearable
      return-object
    ></v-select>
  </div>
</template>

<script>
/*
groupBy
pivot: boolean
columns
  - value
  - aggregation
    - sum
    - avg
    - count
    - min
    - max
*/
import possibleColumns from '@/utils/report/mappings';
import ChooseGroupBy from '@/components/report/items/settings/ChooseGroupBy.vue';

export default {
  mixins: [possibleColumns],
  components: {
    ChooseGroupBy
  },
  data: () => ({
    settings: {
      pivot: false,
      groupBy: [],
    }
  })
}
</script>